import React, { useEffect, useState } from 'react';
import { Icon, Transition } from "semantic-ui-react";
import "./Layout.css"

function BackToTop (){

    const [showButton, setShowButton] = useState(false);

    useEffect(() => {
        window.addEventListener("scroll", () => {
        if (window.pageYOffset > 500) {
            setShowButton(true);
        } else {
            setShowButton(false);
        }
        });
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
        top: 0,
        behavior: 'smooth'
        });
    };

    return(  
            <Transition visible={showButton} animation='scale' duration={500}>
                <button className="backToTop-btn" onClick={scrollToTop}>
                    <Icon className="angle up"></Icon>
                </button>
            </Transition>
    )
    
}
export default BackToTop;